export default __webpack_public_path__ + "static/statsd_metrics_02-3bc9103438bf72704e958a72e108651d.png";